import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../services/api";
import "./RegisterPage.css";

// 다국어 번역 객체 (LoginPage.js와 동일하게 복사/확장)
// 다국어 번역 객체
const translations = {
  ko: {
    register: "회원가입",
    email: "이메일",
    password: "비밀번호",
    confirmPassword: "비밀번호 확인",
    name: "이름",
    organization: "소속기관",
    phoneNumber: "전화번호",
    sendCode: "코드 전송",
    codeSent: "코드 전송이 완료되었습니다!",
    code: "인증 코드",
    verify: "인증하기",
    verified: "인증완료",
    registerButton: "회원가입",
    alreadyHaveAccount: "이미 계정이 있으신가요?",
    login: "로그인",
    emailRequired: "이메일을 입력해주세요.",
    emailInvalid: "올바른 이메일 형식이 아닙니다.",
    passwordRequired: "비밀번호를 입력해주세요.",
    passwordShort: "비밀번호는 8자 이상이어야 합니다.",
    passwordConfirm: "비밀번호가 일치하지 않습니다.",
    nameRequired: "이름을 입력해주세요.",
    phoneInvalid: "올바른 전화번호 형식이 아닙니다.",
    emailVerified: "이메일이 인증되었습니다.",
    verificationRequired: "이메일 인증이 필요합니다.",
    codePlaceholder: "인증 코드 6자리",
    languageSelector: "언어 선택",
    chooseLanguage: "언어를 선택하세요!",
    pwLength: "8자 이상",
    pwUpper: "대문자",
    pwLower: "소문자",
    pwNumber: "숫자",
    pwSpecial: "특수문자",
  },
  en: {
    register: "Register",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    organization: "Organization",
    phoneNumber: "Phone Number",
    sendCode: "Send Code",
    codeSent: "Verification code sent!",
    code: "Verification Code",
    verify: "Verify",
    verified: "Verified",
    registerButton: "Register",
    alreadyHaveAccount: "Already have an account?",
    login: "Login",
    emailRequired: "Please enter your email.",
    emailInvalid: "Invalid email format.",
    passwordRequired: "Please enter your password.",
    passwordShort: "Password must be at least 8 characters.",
    passwordConfirm: "Passwords do not match.",
    nameRequired: "Please enter your name.",
    phoneInvalid: "Invalid phone number format.",
    emailVerified: "Email has been verified.",
    verificationRequired: "Email verification is required.",
    codePlaceholder: "6-digit code",
    languageSelector: "Select Language",
    chooseLanguage: "Choose Your Language!",
    pwLength: "At least 8 characters",
    pwUpper: "Uppercase letter",
    pwLower: "Lowercase letter",
    pwNumber: "Number",
    pwSpecial: "Special character",
  },
  ja: {
    register: "登録",
    email: "メール",
    password: "パスワード",
    confirmPassword: "パスワード確認",
    name: "名前",
    organization: "所属",
    phoneNumber: "電話番号",
    sendCode: "コード送信",
    codeSent: "認証コードを送信しました！",
    code: "認証コード",
    verify: "認証",
    verified: "認証済み",
    registerButton: "登録",
    alreadyHaveAccount: "すでにアカウントをお持ちですか？",
    login: "ログイン",
    emailRequired: "メールアドレスを入力してください。",
    emailInvalid: "正しいメール形式ではありません。",
    passwordRequired: "パスワードを入力してください。",
    passwordShort: "パスワードは8文字以上である必要があります。",
    passwordConfirm: "パスワードが一致しません。",
    nameRequired: "名前を入力してください。",
    phoneInvalid: "正しい電話番号形式ではありません。",
    emailVerified: "メールは認証されました。",
    verificationRequired: "メール認証が必要です。",
    codePlaceholder: "6桁のコード",
    languageSelector: "言語選択",
    chooseLanguage: "言語を選択してください！",
    pwLength: "8文字以上",
    pwUpper: "大文字",
    pwLower: "小文字",
    pwNumber: "数字",
    pwSpecial: "特殊文字",
  },
  "zh-Hans": {
    register: "注册",
    email: "电子邮件",
    password: "密码",
    confirmPassword: "确认密码",
    name: "姓名",
    organization: "组织",
    phoneNumber: "电话号码",
    sendCode: "发送验证码",
    codeSent: "验证码已发送！",
    code: "验证码",
    verify: "验证",
    verified: "已验证",
    registerButton: "注册",
    alreadyHaveAccount: "已经有账户？",
    login: "登录",
    emailRequired: "请输入电子邮件。",
    emailInvalid: "电子邮件格式无效。",
    passwordRequired: "请输入密码。",
    passwordShort: "密码长度至少为8位。",
    passwordConfirm: "密码不匹配。",
    nameRequired: "请输入姓名。",
    phoneInvalid: "电话号码格式无效。",
    emailVerified: "电子邮件已验证。",
    verificationRequired: "需要电子邮件验证。",
    codePlaceholder: "6位验证码",
    languageSelector: "选择语言",
    chooseLanguage: "请选择您的语言！",
    pwLength: "至少8位",
    pwUpper: "大写字母",
    pwLower: "小写字母",
    pwNumber: "数字",
    pwSpecial: "特殊字符",
  },
  es: {
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    name: "Nombre",
    organization: "Organización",
    phoneNumber: "Número de teléfono",
    sendCode: "Enviar código",
    codeSent: "¡Código de verificación enviado!",
    code: "Código de verificación",
    verify: "Verificar",
    verified: "Verificado",
    registerButton: "Registrarse",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    login: "Iniciar sesión",
    emailRequired: "Por favor ingresa tu correo electrónico.",
    emailInvalid: "Formato de correo electrónico inválido.",
    passwordRequired: "Por favor ingresa tu contraseña.",
    passwordShort: "La contraseña debe tener al menos 8 caracteres.",
    passwordConfirm: "Las contraseñas no coinciden.",
    nameRequired: "Por favor ingresa tu nombre.",
    phoneInvalid: "Formato de número de teléfono inválido.",
    emailVerified: "El correo electrónico ha sido verificado.",
    verificationRequired: "Se requiere verificación de correo electrónico.",
    codePlaceholder: "Código de 6 dígitos",
    languageSelector: "Seleccionar idioma",
    chooseLanguage: "¡Elige tu idioma!",
    pwLength: "Al menos 8 caracteres",
    pwUpper: "Letra mayúscula",
    pwLower: "Letra minúscula",
    pwNumber: "Número",
    pwSpecial: "Carácter especial",
  },
  fr: {
    register: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    name: "Nom",
    organization: "Organisation",
    phoneNumber: "Numéro de téléphone",
    sendCode: "Envoyer le code",
    codeSent: "Code de vérification envoyé !",
    code: "Code de vérification",
    verify: "Vérifier",
    verified: "Vérifié",
    registerButton: "S'inscrire",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    login: "Connexion",
    emailRequired: "Veuillez entrer votre e-mail.",
    emailInvalid: "Format d'e-mail invalide.",
    passwordRequired: "Veuillez entrer votre mot de passe.",
    passwordShort: "Le mot de passe doit comporter au moins 8 caractères.",
    passwordConfirm: "Les mots de passe ne correspondent pas.",
    nameRequired: "Veuillez entrer votre nom.",
    phoneInvalid: "Format de numéro de téléphone invalide.",
    emailVerified: "L'e-mail a été vérifié.",
    verificationRequired: "La vérification de l'e-mail est requise.",
    codePlaceholder: "Code à 6 chiffres",
    languageSelector: "Choisir la langue",
    chooseLanguage: "Choisissez votre langue !",
    pwLength: "Au moins 8 caractères",
    pwUpper: "Majuscule",
    pwLower: "Minuscule",
    pwNumber: "Chiffre",
    pwSpecial: "Caractère spécial",
  },
  de: {
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    name: "Name",
    organization: "Organisation",
    phoneNumber: "Telefonnummer",
    sendCode: "Code senden",
    codeSent: "Verifizierungscode gesendet!",
    code: "Verifizierungscode",
    verify: "Überprüfen",
    verified: "Verifiziert",
    registerButton: "Registrieren",
    alreadyHaveAccount: "Sie haben bereits ein Konto?",
    login: "Anmelden",
    emailRequired: "Bitte geben Sie Ihre E-Mail ein.",
    emailInvalid: "Ungültiges E-Mail-Format.",
    passwordRequired: "Bitte geben Sie Ihr Passwort ein.",
    passwordShort: "Das Passwort muss mindestens 8 Zeichen lang sein.",
    passwordConfirm: "Passwörter stimmen nicht überein.",
    nameRequired: "Bitte geben Sie Ihren Namen ein.",
    phoneInvalid: "Ungültiges Telefonnummernformat.",
    emailVerified: "E-Mail wurde verifiziert.",
    verificationRequired: "E-Mail-Verifizierung ist erforderlich.",
    codePlaceholder: "6-stelliger Code",
    languageSelector: "Sprache auswählen",
    chooseLanguage: "Wählen Sie Ihre Sprache!",
    pwLength: "Mindestens 8 Zeichen",
    pwUpper: "Großbuchstabe",
    pwLower: "Kleinbuchstabe",
    pwNumber: "Zahl",
    pwSpecial: "Sonderzeichen",
  },
  ru: {
    register: "Регистрация",
    email: "Электронная почта",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    name: "Имя",
    organization: "Организация",
    phoneNumber: "Номер телефона",
    sendCode: "Отправить код",
    codeSent: "Код подтверждения отправлен!",
    code: "Код подтверждения",
    verify: "Проверить",
    verified: "Подтверждено",
    registerButton: "Зарегистрироваться",
    alreadyHaveAccount: "Уже есть аккаунт?",
    login: "Вход",
    emailRequired: "Пожалуйста, введите электронную почту.",
    emailInvalid: "Неверный формат электронной почты.",
    passwordRequired: "Пожалуйста, введите пароль.",
    passwordShort: "Пароль должен содержать не менее 8 символов.",
    passwordConfirm: "Пароли не совпадают.",
    nameRequired: "Пожалуйста, введите имя.",
    phoneInvalid: "Неверный формат номера телефона.",
    emailVerified: "Электронная почта подтверждена.",
    verificationRequired: "Требуется подтверждение электронной почты.",
    codePlaceholder: "6-значный код",
    languageSelector: "Выберите язык",
    chooseLanguage: "Выберите ваш язык!",
    pwLength: "Не менее 8 символов",
    pwUpper: "Заглавная буква",
    pwLower: "Строчная буква",
    pwNumber: "Цифра",
    pwSpecial: "Специальный символ",
  },
  pt: {
    register: "Registrar",
    email: "E-mail",
    password: "Senha",
    confirmPassword: "Confirmar senha",
    name: "Nome",
    organization: "Organização",
    phoneNumber: "Número de telefone",
    sendCode: "Enviar código",
    codeSent: "Código de verificação enviado!",
    code: "Código de verificação",
    verify: "Verificar",
    verified: "Verificado",
    registerButton: "Registrar",
    alreadyHaveAccount: "Já tem uma conta?",
    login: "Entrar",
    emailRequired: "Por favor, insira seu e-mail.",
    emailInvalid: "Formato de e-mail inválido.",
    passwordRequired: "Por favor, insira sua senha.",
    passwordShort: "A senha deve ter pelo menos 8 caracteres.",
    passwordConfirm: "As senhas não coincidem.",
    nameRequired: "Por favor, insira seu nome.",
    phoneInvalid: "Formato de número de telefone inválido.",
    emailVerified: "O e-mail foi verificado.",
    verificationRequired: "É necessário verificar o e-mail.",
    codePlaceholder: "Código de 6 dígitos",
    languageSelector: "Selecione o idioma",
    chooseLanguage: "Escolha seu idioma!",
    pwLength: "Pelo menos 8 caracteres",
    pwUpper: "Letra maiúscula",
    pwLower: "Letra minúscula",
    pwNumber: "Número",
    pwSpecial: "Caractere especial",
  },
  it: {
    register: "Registrati",
    email: "E-mail",
    password: "Password",
    confirmPassword: "Conferma password",
    name: "Nome",
    organization: "Organizzazione",
    phoneNumber: "Numero di telefono",
    sendCode: "Invia codice",
    codeSent: "Codice di verifica inviato!",
    code: "Codice di verifica",
    verify: "Verifica",
    verified: "Verificato",
    registerButton: "Registrati",
    alreadyHaveAccount: "Hai già un account?",
    login: "Accedi",
    emailRequired: "Per favore inserisci la tua e-mail.",
    emailInvalid: "Formato e-mail non valido.",
    passwordRequired: "Per favore inserisci la tua password.",
    passwordShort: "La password deve essere di almeno 8 caratteri.",
    passwordConfirm: "Le password non corrispondono.",
    nameRequired: "Per favore inserisci il tuo nome.",
    phoneInvalid: "Formato del numero di telefono non valido.",
    emailVerified: "L'e-mail è stata verificata.",
    verificationRequired: "È richiesta la verifica dell'e-mail.",
    codePlaceholder: "Codice di 6 cifre",
    languageSelector: "Seleziona la lingua",
    chooseLanguage: "Scegli la tua lingua!",
    pwLength: "Almeno 8 caratteri",
    pwUpper: "Lettera maiuscola",
    pwLower: "Lettera minuscola",
    pwNumber: "Numero",
    pwSpecial: "Carattere speciale",
  },
  ar: {
    register: "تسجيل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    name: "الاسم",
    organization: "المنظمة",
    phoneNumber: "رقم الهاتف",
    sendCode: "إرسال الرمز",
    codeSent: "تم إرسال رمز التحقق!",
    code: "رمز التحقق",
    verify: "تحقق",
    verified: "تم التحقق",
    registerButton: "تسجيل",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    login: "تسجيل الدخول",
    emailRequired: "يرجى إدخال البريد الإلكتروني.",
    emailInvalid: "تنسيق البريد الإلكتروني غير صالح.",
    passwordRequired: "يرجى إدخال كلمة المرور.",
    passwordShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
    passwordConfirm: "كلمتا المرور غير متطابقتين.",
    nameRequired: "يرجى إدخال الاسم.",
    phoneInvalid: "تنسيق رقم الهاتف غير صالح.",
    emailVerified: "تم التحقق من البريد الإلكتروني.",
    verificationRequired: "مطلوب التحقق من البريد الإلكتروني.",
    codePlaceholder: "رمز مكون من 6 أرقام",
    languageSelector: "اختر اللغة",
    chooseLanguage: "اختر لغتك!",
    pwLength: "8 أحرف على الأقل",
    pwUpper: "حرف كبير",
    pwLower: "حرف صغير",
    pwNumber: "رقم",
    pwSpecial: "رمز خاص",
  },
  hi: {
    register: "पंजीकरण",
    email: "ईमेल",
    password: "पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    name: "नाम",
    organization: "संगठन",
    phoneNumber: "फ़ोन नंबर",
    sendCode: "कोड भेजें",
    codeSent: "सत्यापन कोड भेज दिया गया!",
    code: "सत्यापन कोड",
    verify: "सत्यापित करें",
    verified: "सत्यापित",
    registerButton: "पंजीकरण",
    alreadyHaveAccount: "क्या आपके पास पहले से एक खाता है?",
    login: "लॉगिन",
    emailRequired: "कृपया अपना ईमेल दर्ज करें।",
    emailInvalid: "अमान्य ईमेल प्रारूप।",
    passwordRequired: "कृपया अपना पासवर्ड दर्ज करें।",
    passwordShort: "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए।",
    passwordConfirm: "पासवर्ड मेल नहीं खाते।",
    nameRequired: "कृपया अपना नाम दर्ज करें।",
    phoneInvalid: "अमान्य फोन नंबर प्रारूप।",
    emailVerified: "ईमेल सत्यापित हो गया है।",
    verificationRequired: "ईमेल सत्यापन आवश्यक है।",
    codePlaceholder: "6-अंकीय कोड",
    languageSelector: "भाषा चुनें",
    chooseLanguage: "अपनी भाषा चुनें!",
    pwLength: "कम से कम 8 अक्षर",
    pwUpper: "बड़ा अक्षर",
    pwLower: "छोटा अक्षर",
    pwNumber: "संख्या",
    pwSpecial: "विशेष वर्ण",
  },
  tr: {
    register: "Kayıt Ol",
    email: "E-posta",
    password: "Şifre",
    confirmPassword: "Şifreyi Onayla",
    name: "İsim",
    organization: "Kuruluş",
    phoneNumber: "Telefon Numarası",
    sendCode: "Kod Gönder",
    codeSent: "Doğrulama kodu gönderildi!",
    code: "Doğrulama Kodu",
    verify: "Doğrula",
    verified: "Doğrulandı",
    registerButton: "Kayıt Ol",
    alreadyHaveAccount: "Zaten hesabınız var mı?",
    login: "Giriş Yap",
    emailRequired: "Lütfen e-postanızı girin.",
    emailInvalid: "Geçersiz e-posta formatı.",
    passwordRequired: "Lütfen şifrenizi girin.",
    passwordShort: "Şifre en az 8 karakter olmalıdır.",
    passwordConfirm: "Şifreler eşleşmiyor.",
    nameRequired: "Lütfen adınızı girin.",
    phoneInvalid: "Geçersiz telefon numarası formatı.",
    emailVerified: "E-posta doğrulandı.",
    verificationRequired: "E-posta doğrulaması gerekiyor.",
    codePlaceholder: "6 haneli kod",
    languageSelector: "Dil Seç",
    chooseLanguage: "Dilini Seç!",
    pwLength: "En az 8 karakter",
    pwUpper: "Büyük harf",
    pwLower: "Küçük harf",
    pwNumber: "Rakam",
    pwSpecial: "Özel karakter",
  },
};

// 지원 언어 목록
const supportedLanguages = [
  { code: "ko", name: "한국어" },
  { code: "en", name: "English" },
  { code: "ja", name: "日本語" },
  { code: "zh-Hans", name: "简体中文" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
  { code: "ru", name: "Русский" },
  { code: "pt", name: "Português" },
  { code: "it", name: "Italiano" },
  { code: "ar", name: "العربية" },
  { code: "hi", name: "हिन्दी" },
  { code: "tr", name: "Türkçe" },
];

const getText = (language, key) => {
  if (translations[language] && translations[language][key]) {
    return translations[language][key];
  }
  if (translations["en"] && translations["en"][key]) {
    return translations["en"][key];
  }
  return key;
};

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    organization: "", // 선택사항으로 변경
    phoneNumber: "",
  });
  const [verificationCode, setVerificationCode] = useState("");
  const [errors, setErrors] = useState({});
  const [passwordRequirements, setPasswordRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [codeSendSuccess, setCodeSendSuccess] = useState(false);
  const [language, setLanguage] = useState("ko");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("i2m_language");
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    setLanguage(newLanguage);
    localStorage.setItem("i2m_language", newLanguage);
  };

  // 비밀번호 실시간 유효성 검사
  const validatePassword = (password) => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 비밀번호 입력 시 실시간 유효성 검사
    if (name === "password") {
      setPasswordRequirements(validatePassword(value));
      // 비밀번호 변경 시 비밀번호 확인 필드도 체크
      if (formData.confirmPassword) {
        if (value !== formData.confirmPassword) {
          setErrors((prev) => ({
            ...prev,
            confirmPassword: "비밀번호가 일치하지 않습니다.",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            confirmPassword: "",
          }));
        }
      }
    }

    // 비밀번호 확인 입력 시 실시간 체크
    if (name === "confirmPassword") {
      if (value !== formData.password) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "비밀번호가 일치하지 않습니다.",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "",
        }));
      }
    }

    // 다른 필드의 에러 메시지 제거
    if (name !== "confirmPassword" && errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // 이메일 검증
    if (!formData.email) {
      newErrors.email = "이메일을 입력해주세요.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "올바른 이메일 형식이 아닙니다.";
    }

    // 비밀번호 검증
    if (!formData.password) {
      newErrors.password = "비밀번호를 입력해주세요.";
    } else if (formData.password.length < 8) {
      newErrors.password = "비밀번호는 8자 이상이어야 합니다.";
    }

    // 비밀번호 확인 검증
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "비밀번호가 일치하지 않습니다.";
    }

    // 이름 검증
    if (!formData.name) {
      newErrors.name = "이름을 입력해주세요.";
    }

    // 전화번호 검증 (선택적)
    if (
      formData.phoneNumber &&
      !/^\d{10,11}$/.test(formData.phoneNumber.replace(/-/g, ""))
    ) {
      newErrors.phoneNumber = "올바른 전화번호 형식이 아닙니다.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // 이메일 인증 여부 확인 추가
    if (!isEmailVerified) {
      setErrors({
        submit: "이메일 인증이 필요합니다.",
      });
      return;
    }

    try {
      // authAPI.goRegister 함수 사용하여 회원가입 처리
      const response = await authAPI.goRegister({
        email: formData.email,
        password: formData.password,
        name: formData.name,
        organization: formData.organization || null,
        phoneNumber: formData.phoneNumber || null,
      });

      if (response.success) {
        // 회원가입 성공 시 로그인 페이지로 이동
        alert("회원가입이 완료되었습니다. 로그인 페이지로 이동합니다.");
        navigate("/login");
      } else {
        // 응답에 success는 있지만 false인 경우 (논리적 오류)
        setErrors({
          submit: response.message || "회원가입 중 오류가 발생했습니다.",
        });
      }
    } catch (error) {
      console.error("회원가입 오류:", error);

      // 서버에서 반환된 오류 메시지 처리
      let errorData = error.response?.data;

      // API Gateway가 반환한 응답이 { statusCode, body } 형태인 경우
      if (errorData && typeof errorData.body === "string") {
        try {
          // body 문자열을 파싱하여 실제 오류 정보 추출
          errorData = JSON.parse(errorData.body);
          console.log("파싱된 오류 데이터:", errorData);
        } catch (parseError) {
          console.error("오류 응답 파싱 실패:", parseError);
        }
      }

      if (errorData && errorData.errorCode) {
        // 오류 코드에 따른 처리
        switch (errorData.errorCode) {
          case "EMAIL_ALREADY_EXISTS":
            setErrors({
              email: "이미 등록된 이메일입니다.",
              submit: null,
            });
            break;
          case "DATABASE_ERROR":
            setErrors({
              submit:
                "데이터베이스 오류가 발생했습니다: " +
                (errorData.details || errorData.message),
            });
            break;
          case "SERVER_ERROR":
            setErrors({
              submit:
                "서버 오류가 발생했습니다: " +
                (errorData.details || errorData.message),
            });
            break;
          default:
            setErrors({
              submit: errorData.message || "회원가입 중 오류가 발생했습니다.",
            });
        }
      } else {
        // 응답에 오류 정보가 없는 경우 (네트워크 오류 등)
        setErrors({
          submit: "서버에 연결할 수 없습니다. 인터넷 연결을 확인해주세요.",
        });
      }
    }
  };

  const handleVerification = async () => {
    try {
      // 이메일 인증 - 새로운 checkVerificationCode API 사용
      const response = await authAPI.checkVerificationCode({
        email: formData.email,
        code: verificationCode,
      });

      if (response.success) {
        setIsEmailVerified(true);
        setErrors((prev) => ({
          ...prev,
          verification: "",
        }));
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        verification:
          error.response?.data?.message || getText(language, "invalidCode"),
      }));
    }
  };

  const handleSendVerification = async () => {
    try {
      await authAPI.sendVerificationCode(formData.email);
      setIsCodeSent(true);
      setCodeSendSuccess(true);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        email:
          error.response?.data?.message ||
          getText(language, "sendCode") + " 실패",
      }));
      setCodeSendSuccess(false);
    }
  };

  return (
    <div className="register-container">
      {/* 언어 선택 드롭다운 */}
      <div className="language-selector-container">
        <h2 className="language-title">
          {getText(language, "chooseLanguage")}
        </h2>
        <div className="language-selector">
          <select value={language} onChange={handleLanguageChange}>
            {supportedLanguages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="register-box">
        <h1>{getText(language, "register")}</h1>
        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <label htmlFor="email">{getText(language, "email")} *</label>
            <div className="input-with-button">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "error" : ""}
                disabled={isEmailVerified || codeSendSuccess}
                placeholder={getText(language, "email")}
              />
              <button
                type="button"
                className="code-send-button"
                onClick={handleSendVerification}
                disabled={isEmailVerified || codeSendSuccess}
              >
                {isEmailVerified
                  ? getText(language, "verified")
                  : codeSendSuccess
                  ? getText(language, "codeSent")
                  : getText(language, "sendCode")}
              </button>
            </div>
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
            {codeSendSuccess && !isEmailVerified && (
              <span className="success-message">
                {getText(language, "codeSent")}
              </span>
            )}
            {isEmailVerified && (
              <span className="success-message">
                {getText(language, "emailVerified")}
              </span>
            )}
          </div>

          {isCodeSent && !isEmailVerified && (
            <div className="form-group">
              <label htmlFor="verificationCode">
                {getText(language, "code")}
              </label>
              <div className="input-with-button">
                <input
                  type="text"
                  id="verificationCode"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder={getText(language, "codePlaceholder")}
                />
                <button
                  type="button"
                  className="verify-button"
                  onClick={handleVerification}
                >
                  {getText(language, "verify")}
                </button>
              </div>
              {errors.verification && (
                <span className="error-message">{errors.verification}</span>
              )}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="password">{getText(language, "password")} *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? "error" : ""}
              placeholder={getText(language, "password")}
            />
            <div className="password-requirements">
              <small>비밀번호 조건</small>
              <ul>
                <li className={passwordRequirements.length ? "met" : ""}>
                  <span className="requirement-icon">
                    {passwordRequirements.length ? "✓" : "•"}
                  </span>
                  {getText(language, "pwLength")}
                </li>
                <li className={passwordRequirements.uppercase ? "met" : ""}>
                  <span className="requirement-icon">
                    {passwordRequirements.uppercase ? "✓" : "•"}
                  </span>
                  {getText(language, "pwUpper")}
                </li>
                <li className={passwordRequirements.lowercase ? "met" : ""}>
                  <span className="requirement-icon">
                    {passwordRequirements.lowercase ? "✓" : "•"}
                  </span>
                  {getText(language, "pwLower")}
                </li>
                <li className={passwordRequirements.number ? "met" : ""}>
                  <span className="requirement-icon">
                    {passwordRequirements.number ? "✓" : "•"}
                  </span>
                  {getText(language, "pwNumber")}
                </li>
                <li className={passwordRequirements.special ? "met" : ""}>
                  <span className="requirement-icon">
                    {passwordRequirements.special ? "✓" : "•"}
                  </span>
                  {getText(language, "pwSpecial")}
                </li>
              </ul>
            </div>
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">
              {getText(language, "confirmPassword")} *
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className={errors.confirmPassword ? "error" : ""}
              placeholder={getText(language, "confirmPassword")}
            />
            {errors.confirmPassword && (
              <span className="error-message">{errors.confirmPassword}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="name">{getText(language, "name")} *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error" : ""}
              placeholder={getText(language, "name")}
            />
            {errors.name && (
              <span className="error-message">{errors.name}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="organization">
              {getText(language, "organization")}
            </label>
            <input
              type="text"
              id="organization"
              name="organization"
              value={formData.organization}
              onChange={handleChange}
              placeholder={getText(language, "organization")}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phoneNumber">
              {getText(language, "phoneNumber")}
            </label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className={errors.phoneNumber ? "error" : ""}
              placeholder={getText(language, "phoneNumber")}
            />
            {errors.phoneNumber && (
              <span className="error-message">{errors.phoneNumber}</span>
            )}
          </div>

          {errors.submit && (
            <div className="error-message submit-error">{errors.submit}</div>
          )}

          <button type="submit" className="register-button">
            {getText(language, "registerButton")}
          </button>
        </form>

        <div className="login-link">
          {getText(language, "alreadyHaveAccount")}
          <a href="/login">{getText(language, "login")}</a>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
